import axios from 'axios';
import { auth } from '../firebase/config';
import { apiBase } from './apiBase.mjs';
import { requireRequestScope, type RequestScope } from './requestScope.mjs';
declare module 'axios' { interface AxiosRequestConfig { sparkScope?: RequestScope; sparkDiscoveryOrganization?: string } }

const apiClient = axios.create({
  baseURL: apiBase(import.meta.env.VITE_API_BASE_URL),
  headers: {
    'Content-Type': 'application/json',
  },
});

apiClient.interceptors.request.use(async (config) => {
  const currentScope = () => ({organizationId: localStorage.getItem('spark_org_id'), workspaceId: localStorage.getItem('spark_workspace_id'), userId: auth.currentUser?.uid ?? null});
  requireRequestScope(config.sparkScope, currentScope());
  // 1. Inject Firebase ID Token
  const user = auth.currentUser;
  if (user) {
    const token = await user.getIdToken();
    if(config.sparkScope && auth.currentUser?.uid !== user.uid) throw new Error('Session changed; request cancelled');
    requireRequestScope(config.sparkScope, currentScope());
    config.headers.Authorization = `Bearer ${token}`;
  }

  // Discovery must authenticate the user without replaying a stale tenant selection.
  if (config.url?.split('?')[0] === '/api/v1/auth/context') {
    delete config.headers['X-Organization-ID'];
    delete config.headers['X-Workspace-ID'];
    if (config.sparkDiscoveryOrganization) {
      config.headers['X-Organization-ID'] = config.sparkDiscoveryOrganization;
      config.params = { organizationId: config.sparkDiscoveryOrganization };
    }
    return config;
  }

  // 2. Inject Organization Context
  const orgId = localStorage.getItem('spark_org_id');
  if (orgId) {
    config.headers['X-Organization-ID'] = orgId;
  }

  // 3. Inject Workspace Context
  const workspaceId = localStorage.getItem('spark_workspace_id');
  if (workspaceId) {
    config.headers['X-Workspace-ID'] = workspaceId;
  }

  return config;
}, (error) => {
  return Promise.reject(error);
});

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Handle session expiration
      console.warn('Session expired or unauthorized.');
    }
    return Promise.reject(error);
  }
);

export default apiClient;
